<script setup>
// Campo de telefone internacional: guarda o valor em E.164 (+dígitos) e formata enquanto digita,
// usando as regras do libphonenumber para qualquer país.
import { computed } from 'vue';
import { AsYouType } from 'libphonenumber-js';
import Input from 'dashboard/components-next/input/Input.vue';

defineProps({
  label: { type: String, default: '' },
  placeholder: { type: String, default: '+55 69 99310-7167' },
  size: { type: String, default: 'md' },
  disabled: { type: Boolean, default: false },
});

const modelValue = defineModel({ type: String, default: '' });

const digitsOf = value => String(value ?? '').replace(/\D/g, '');
const displayValue = computed(() =>
  modelValue.value
    ? new AsYouType().input(`+${digitsOf(modelValue.value)}`)
    : ''
);

const onInput = value => {
  const typed = String(value ?? '');
  let digits = digitsOf(typed);
  // apagar um caractere da máscara precisa apagar o dígito anterior a ele
  if (
    typed.length < displayValue.value.length &&
    digits === digitsOf(modelValue.value)
  ) {
    digits = digits.slice(0, -1);
  }
  modelValue.value = digits ? `+${digits}` : '';
};
</script>

<template>
  <Input
    :model-value="displayValue"
    :label="label"
    :placeholder="placeholder"
    :size="size"
    :disabled="disabled"
    type="tel"
    @update:model-value="onInput"
  />
</template>
